import React, { useState, useContext } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Hidden from '@material-ui/core/Hidden'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem'

import AlertDialog from '../AlertDialog'

import dayjs from 'dayjs'

import _appContext from '../../contexts/appContext'
import _firebaseContext from '../../contexts/firebaseContext'

export default function MessageEdit({ open, handleClose, message, languageList }) {
    const [performingAction, setPerformingAction] = useState(true)
    const [messageField, setMessageField] = useState(message.data.message)
    const [alertDialogState, setAlertDialogState] = useState(false)

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)


    const handleMessageChange = event => {
        setMessageField(event.target.value)
    }

    const handleDeleteRequest = event => {
        // handleClose()
        setAlertDialogState(true);
        // firebaseContext.deleteMessage(message.id)
    }

    const handleDelete = state => {
        setAlertDialogState(false);

        if (state) {
            handleClose()
            firebaseContext.deleteMessage(message.id);
        }
    }

    const handleSave = async event => {
        const updatedMessage = {
            message: messageField,
        }

        let result = await firebaseContext.updateMessage(
            message.id,
            updatedMessage
        )

        if (result.error) {
            if (result.firebaseError !== undefined) {
                const code = result.firebaseError.errorInfo.code
                let reason = code
            }
        } else {
            handleClose()
        }
        appContext.snackbar.showSnackbarMsg(result.message)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="form-dialog-title">
                    Редактирование сообщения {message.id}
                </DialogTitle>
                <DialogContent>
                    <InputLabel shrink id="language">
                        Язык
                    </InputLabel>
                    <Select
                        value={message.data.locale}
                        disabled={true}
                        labelId="language"
                    >
                        {languageList && languageList.map(language => <MenuItem value={language.id} key={language.id}>{language.data.represent}</MenuItem>)}
                    </Select>
                </DialogContent>
                <DialogContent>
                    {/* <Hidden xsDown>
                        <ListItemIcon>
                            <Avatar alt="user avatar" src={message.photoURL} />
                        </ListItemIcon>
                    </Hidden> */}
                    <Typography variant="body2" color="textSecondary">
                        ID пользователя
                    </Typography>
                    <Typography variant="body1" color="textPrimary">
                        {message.data.userId}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Имя пользователя
                    </Typography>
                    <Typography variant="body1" color="textPrimary">
                        {message.data.userName}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Дата публикации
                    </Typography>
                    <Typography variant="body1" color="textPrimary">
                        {dayjs(message.data.dateTime).format('DD/MM/YYYY HH:mm:ss')}
                    </Typography>
                    {/* <List>
                        <ListItem> */}
                    <TextField
                        autoFocus
                        disabled={!performingAction}
                        // error={!!(errors && errors.firstName)}
                        fullWidth
                        label="Текст сообщения"
                        type="text"
                        value={messageField}
                        // className={styles.textfield}
                        // onKeyDown={(event) => this.handleKeyDown(event, 'first-name')}
                        multiline
                        onChange={handleMessageChange}
                    />
                    {/* </ListItem>
                    </List> */}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleDeleteRequest}
                        color="secondary"
                        style={{ marginRight: 'auto' }}
                    >
                        Удалить
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
            <AlertDialog
                open={alertDialogState}
                title="Удаление сообщения"
                text="Вы уверены, что хотите удалить сообщение"
                handleClose={handleDelete}
            />
        </>
    )
}
